import s, { forwardRef as f } from "react";
import l from "./index.es437.js";
function a() {
  return a = Object.assign || function(r) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var e in t)
        Object.prototype.hasOwnProperty.call(t, e) && (r[e] = t[e]);
    }
    return r;
  }, a.apply(this, arguments);
}
function c(r, o) {
  if (r == null) return {};
  var t = g(r, o), e, n;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(r);
    for (n = 0; n < i.length; n++)
      e = i[n], !(o.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(r, e) && (t[e] = r[e]);
  }
  return t;
}
function g(r, o) {
  if (r == null) return {};
  var t = {}, e = Object.keys(r), n, i;
  for (i = 0; i < e.length; i++)
    n = e[i], !(o.indexOf(n) >= 0) && (t[n] = r[n]);
  return t;
}
var p = f(function(r, o) {
  var t = r.color, e = t === void 0 ? "currentColor" : t, n = r.size, i = n === void 0 ? 24 : n, u = c(r, ["color", "size"]);
  return /* @__PURE__ */ s.createElement("svg", a({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: e,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, u), /* @__PURE__ */ s.createElement("polyline", {
    points: "23 6 13.5 15.5 8.5 10.5 1 18"
  }), /* @__PURE__ */ s.createElement("polyline", {
    points: "17 6 23 6 23 12"
  }));
});
p.propTypes = {
  color: l.string,
  size: l.oneOfType([l.string, l.number])
};
p.displayName = "TrendingUp";
export {
  p as default
};
//# sourceMappingURL=index.es368.js.map
